import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { IVendorRole } from '@/api/types-vendor'

export const defaultVendorRoleData: IVendorRole = {
  vendorRoleId: 0,
  name: '',
  description: ''
}

export interface IVendorRolesState {
  VendorRoleList: IVendorRole[]
  VendorRoleSelected: (IVendorRole | null)
}

@Module({ dynamic: true, store, name: 'VendorRole' })
class VendorRoles extends VuexModule implements IVendorRolesState {
  public VendorRoleList: IVendorRole[] = []
  public VendorRoleSelected: IVendorRole | null = null

  @Mutation
  private DEL_ALL_VENDORROLES() {
    this.VendorRoleList = []
  }

  @Mutation
  private LOAD_VENDORROLES(VendorRoles: IVendorRole[]) {
    this.VendorRoleList = VendorRoles
  }

  // GETTERS
  get cachedVendorRoles() {
    return this.VendorRoleList
  }

  @Action
  public loadVendorRoles(VendorRoles: IVendorRole[]) {
    this.DEL_ALL_VENDORROLES()
    this.LOAD_VENDORROLES(VendorRoles)
  }
}

export const VendorRoleModule = getModule(VendorRoles)
